import { render } from "./InfoVerificationPage.vue?vue&type=template&id=041e7601&scoped=true"
import script from "./InfoVerificationPage.vue?vue&type=script&lang=js"
export * from "./InfoVerificationPage.vue?vue&type=script&lang=js"

import "./InfoVerificationPage.vue?vue&type=style&index=0&id=041e7601&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041e7601"]])

export default __exports__